import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { HiHome, HiMail } from "react-icons/hi";
import Footer from "../components/Footer/Footer";

const NotFound = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	return (
		<>
		<section className="min-h-[80vh] bg-gradient-to-br from-cream via-warm to-cream dark:from-slate-900 dark:via-slate-800 dark:to-slate-900 flex items-center justify-center relative overflow-hidden">
			{/* Background decorations */}
			<div className="absolute top-20 left-10 w-72 h-72 bg-accent/10 rounded-full blur-3xl animate-pulse-slow"></div>
			<div className="absolute bottom-20 right-10 w-96 h-96 bg-slate-400/10 rounded-full blur-3xl animate-pulse-slow animate-delay-300"></div>

			<div className="container mx-auto px-6 text-center relative z-10">
				<div className="animate-fade-in-down">
					{/* 404 Number */}
					<h1 className="text-8xl md:text-9xl font-bold text-accent mb-4">
						404
					</h1>

					{/* Title */}
					<h2 className="text-2xl md:text-3xl font-bold text-slate-800 dark:text-white mb-4">
						{t("notFound.title", "Page Not Found")}
					</h2>

					{/* Description */}
					<p className="text-gray-600 dark:text-gray-300 text-lg max-w-md mx-auto mb-8">
						{t("notFound.description", "The page you're looking for doesn't exist or has been moved.")}
					</p>

					{/* Buttons */}
					<div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up animate-delay-200">
						<button
							onClick={() => navigate("/")}
							className="primary-btn flex items-center justify-center gap-2 px-8 py-4"
						>
							<HiHome className="text-xl" />
							{t("notFound.homeButton", "Go Home")}
						</button>
						<button
							onClick={() => navigate("/contact-us")}
							className="secondary-btn flex items-center justify-center gap-2 px-8 py-4"
						>
							<HiMail className="text-xl" />
							{t("notFound.contactButton", "Contact Us")}
						</button>
					</div>
				</div>
			</div>
		</section>
		<Footer />
		</>
	);
};

export default NotFound;
